import { PureComponent } from "react";
import { Button as KButton } from "@progress/kendo-react-buttons";
import { Badge, BadgeContainer } from "@progress/kendo-react-indicators";

import { Icon, IconType } from "../Icon/Icon";

import type { RefObject } from "react";
import type { ButtonHandle, ButtonProps as KButtonProps } from "@progress/kendo-react-buttons";

import "./Button.scss";

export enum ButtonMode {
  Default,
  Transparent,
  Clear,
}

interface ButtonProps extends KButtonProps {
  iconType?: IconType;
  className?: string;
  // TODO: why our styles are so different? see fcCard
  useKendoClassName?: boolean;
  tooltip?: string;
  onClick?: (e: React.MouseEvent) => void;
  // TODO: consider making this a list of strings instead
  mode?: ButtonMode;
  label?: string;
  showMenu?: boolean;
  iconPosition?: "left" | "right";
  badge?: string | number;
  danger?: boolean;
  btnRef?: RefObject<ButtonHandle> | null;
}

export class Button extends PureComponent<ButtonProps> {
  htmlElement: HTMLSpanElement | null = null;

  render() {
    const {
      iconType,
      className,
      label,
      useKendoClassName,
      mode,
      danger,
      badge,
      iconPosition,
      showMenu,
      children,
      btnRef,
      ...otherProps
    } = this.props;

    const hasIcon = iconType ? "has-icon" : "";
    const cn = className || "";
    const iconOnly = hasIcon && !label ? "icon-only" : "";
    let classNameCombined = useKendoClassName ? "" : `${cn} ${hasIcon} ${iconOnly} tc-button`;
    let buttonMode: "clear" | "flat" | undefined;

    switch (mode) {
      case ButtonMode.Clear:
        buttonMode = "clear";
        break;
      case ButtonMode.Transparent:
        buttonMode = "flat";
        break;
      case ButtonMode.Default:
      default:
        buttonMode = undefined;
        break;
    }

    if (danger) {
      classNameCombined += " tc-danger";
    }

    return (
      <KButton ref={btnRef} className={classNameCombined} fillMode={buttonMode} {...otherProps}>
        {typeof badge !== "undefined" && (
          <BadgeContainer>
            <Icon type={iconType} />
            <Badge themeColor="tertiary">{badge}</Badge>
          </BadgeContainer>
        )}
        {!badge && iconType && iconPosition !== "right" && <Icon type={iconType} />}
        {label && (
          <span
            className="label"
            ref={(e) => {
              this.htmlElement = e;
            }}
          >
            {label}
          </span>
        )}
        {children}
        {iconType && iconPosition === "right" && <Icon type={iconType} className="right" />}
        {showMenu && typeof label !== "undefined" && (
          <Icon type={IconType.ChevronDown} className="tc-btn-transparent tc-icon-button tc-menu" />
        )}
      </KButton>
    );
  }
}
